import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { premiumStoresListQueries } from '@/services/premiumStores/premiumStores.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const usePremiumStoreMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('togglePremiumStoresStatus', {
    onSuccess: async (data) => {
      await revalidate(['editorRecommendedStores']);
      await queryClient.invalidateQueries({ queryKey: premiumStoresListQueries.all('A') });
      toast.success(data.message);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};
